import clsx from "clsx"
import { CommunitySection } from "../enums/CommunitySection";

type Props = {
    search: string;
    setSearch: (value: string) => void;
    sectionSelected: CommunitySection;
    onSectionSelect: (section: CommunitySection) => void;
}

export const CommunityToolbar = ({ search, setSearch, sectionSelected, onSectionSelect }: Props) => {

    return (
        <div className="community-list-toolbar">
            <div className="community-list-types">
                <button 
                    className={clsx({ "active-type": sectionSelected===CommunitySection.openDiscussions })}
                    onClick={() => onSectionSelect(CommunitySection.openDiscussions)}
                >
                    Open Forum
                </button>

                <div className="divider">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="20" viewBox="0 0 1 20" fill="none">
                        <path d="M0.5 0V20" stroke="#B4B4B4"/>
                    </svg>
                </div>

                <button 
                    className={clsx({ "active-type": sectionSelected===CommunitySection.mastermindCircles })}
                    onClick={() => onSectionSelect(CommunitySection.mastermindCircles)}    
                >
                    Mastermind Circles 
                </button>
            </div>


            <div className="community-list-search">
                <div className="community-list-search-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.5 17.5L13.875 13.875" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <input type="text" placeholder="Search" value={search}  onChange={(e) => setSearch(e.target.value ?? '')} />
            </div>

        </div>
    )
}